import React, { memo, useCallback } from 'react';

import { Tooltip } from 'antd';
import _ from 'lodash';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import { store } from 'appRedux/store/index';
import { FILTER_COLUMNS, FLOAT_COLUMNS, ROUND_COLUMNS, TOTAL_COLUMNS } from 'components/DiamondList/table-config';
import OpenNotification from 'components/common/CommonButton/OpenNotification';

import UtilService from 'services/util';

import { BASE_DOWNLOAD_URL, trackTypeObj, LOCAL_STORAGE_VAR, DIAMONDCONFIRM, BASE_URL } from 'constants/Common';
import {
  SEARCH_DIAMOND_LIST,
  FETCH_CONFIRM_STONE,
  FETCH_DIAMOND_TRACK,
  CREATE_TRACK,
  UPDATE_TRACK,
  PRINT_PDF,
  EXPORT_EXCEL,
  CONFIRM_STONE,
  DELETE_TRACK,
  CREATE_BID,
  UPDATE_BID,
  SEND_EMAIL_XRAY,
  CREATE_MATCH_PAIR,
  DOWNLOAD_ZIP,
  DOWNLOAD_FILE,
  BID_PAGINATE,
  DOWNLOAD_ZIP_EXCEL,
  PROJECT_SETTING,
  BID_CART_PAGINATE,
  FETCH_OFFICE_DIAMOND,
  DELETE_OFFICE_DIAMOND,
} from 'constants/apiConstant';

import downArrowGreen from 'assets/svg/downArrowGreen.gif';
import upArrowRed from 'assets/svg/upArrowRed.gif';

import belgiumImg from 'assets/img/Flags/belgium.png';
import dubaiImg from 'assets/img/Flags/dubai.png';
import hongkongImg from 'assets/img/Flags/hongkong.png';
import indiaImg from 'assets/img/Flags/india.svg';
import usaImg from 'assets/img/Flags/usa.jpg';
import { diatrack } from 'util/diatrack';

const FLAGICON = {
  INDIA: indiaImg,
  HONGKONG: hongkongImg,
  NEWYORK: usaImg,
  DUBAI: dubaiImg,
  BELGIUM: belgiumImg,
};

export const LISTINGPAGES = {
  LIST: 'diamond-list',
  DETAILS: 'diamond-detail',
  DETAIL: 'diamond-detail',
  UPCOMING: 'upcoming',
  DASHBOARD: 'dashboard',
  SEARCH: 'diamond-search',
  FANCY_SEARCH: 'fancy-search',
  CART: 'cart',
  WATCHLIST: 'watchlist',
  REMINDER: 'reminder',
  CONFIRM: 'confirm-list',
  BID: 'new-arrival-bid-it',
  QUOTE: 'quote-list',
  STONE_OF_DAY: 'best-buy',
  NEWARR: 'new-arrivals',
  MATCHPAIR: 'match-pair',
  OFFICE: 'office-list',
  PURCHASE: 'my-purchase',
  SAVEDSEARCH: 'saved-search',
  MYDEMAND: 'my-demand',
  SEARCH_DIAMOND: 'search-bid-diamond',
  MYBID: 'my-bid',
  FEATURED_STONE: 'featured-stone',
};

export const TITLE = {
  [LISTINGPAGES.LIST]: 'Diamond List',
  [LISTINGPAGES.UPCOMING]: 'Upcoming',
  BID: 'Bid',
  [LISTINGPAGES.STONE_OF_DAY]: 'Best Buy',
  [LISTINGPAGES.NEWARR]: 'New Arrivals',
  [LISTINGPAGES.MATCHPAIR]: 'Match Pair',
  [LISTINGPAGES.QUOTE]: 'Offer',
  [LISTINGPAGES.CART]: 'Cart',
  [LISTINGPAGES.WATCHLIST]: 'Watchlist',
  [LISTINGPAGES.REMINDER]: 'Reminder',
  [LISTINGPAGES.CONFIRM]: 'Order List',
  [LISTINGPAGES.OFFICE]: 'Office List',
  [LISTINGPAGES.PURCHASE]: 'Purchase',
  [LISTINGPAGES.FEATURED_STONE]: 'Featured Stone',
};

export const getPath = () => window.location.pathname.split('/').pop();

export function formatNumber(num) {
  return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0;
}

const ColumnFilter = memo((props) => {
  const {
    column: { filterValue = [], setFilter, preFilteredRows, id, isSorted },
  } = props;
  const availableOptions = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      if (!filterValue.includes(row.values[id])) {
        options.add(row.values[id]);
      }
    });
    return [...options.values()];
  }, [id, preFilteredRows, filterValue]);

  const toggleFilter = useCallback(
    (id) => {
      const selectedFilters = [...filterValue];
      if (selectedFilters.includes(id)) {
        selectedFilters.splice(
          selectedFilters.findIndex((x) => x == id),
          1,
        );
      } else {
        selectedFilters.push(id);
      }
      setFilter(selectedFilters);
    },
    [setFilter, filterValue],
  );

  return (
    <div className="llfilterMenuDropdown" style={isSorted ? { borderTop: '1px solid #e9ebf0' } : {}}>
      {filterValue && filterValue.length > 0 && (
        <ul className="llfilterSelect">
          <div className="llSortingTitle">Selected Filter</div>
          {filterValue.map((x) => {
            return (
              <li key={`columnFilter_${id}${x}`}>
                {x}
                <div className="closeFilter" onClick={() => toggleFilter(x)}>
                  <img src={require('assets/svg/DiamondList/close-black.svg')} alt="icon" />
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {availableOptions.length > 1 ? (
        <ul>
          <div className="llSortingTitle">Select Filter</div>
          {availableOptions.map((x) => {
            return (
              <li key={`columnFilter_${id}${x}`} onClick={() => toggleFilter(x)}>
                {x}
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
});

function filterArrayIncludes(rows, id, filterValue = []) {
  if (filterValue.length === 0) return rows;
  return rows.filter((row) => filterValue.includes(row.values[id]));
}
filterArrayIncludes.autoRemove = (val) => !val || !val.length;

export function isMobile() {
  return window.innerWidth <= 767 ? true : false;
}
export function isIpad() {
  return window.innerWidth <= 991 ? true : false;
}

export function fetchBid(state, configId, subTypeCode, status, cb, historyTab) {
  const obj = BID_PAGINATE;
  obj.request = {
    page: state.page,
    limit: state.limit,
    sort: state.sort,
    status: status,
    from: state.date.from ? state.date.from.toISOString() : null,
    to: state.date.to ? state.date.to.toISOString() : null,
    bidConfigurationType: getPath() === LISTINGPAGES.MYDEALOFDAYLIST ? 2 : undefined,
  };

  if (!historyTab) {
    obj.request.bidConfigurationId = configId;
    obj.request.subTypeCode = subTypeCode;
  }

  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    let inTrackDiamonds = [];
    const filterArray = {};
    if (data && data.code === 'OK') {
      rows = data.data.list.map((x) => ({
        ...x.diamond,
        _original: x,
        trackId: x.id,
        bidAmount: x.bidAmount,
        bidDiscount: x.bidDiscount,
        bidPricePerCarat: x.bidPricePerCarat,
        bidType: x.bidType,
        status: x.status,
        updatedAt: x.updatedAt,
        grpBy: x.updatedAt.split('T')[0],
        isLowerBid: x.isLowerBid,
      }));
      // if (type.length === 2) {
      const grp = _.groupBy(rows, 'grpBy');
      rows = [];
      Object.keys(grp).map((grpNo) => {
        const val = grp[grpNo];
        val[0].isBidHeader = true;
        val[0].groupingTitle = moment(val[0].updatedAt).format('DD/MM/YYYY');
        rows = [...rows, ...val];
      });
      // }
      sum = data.data.total[0];
      count = data.data.count;
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchBidCart(cb) {
  return new Promise((resolve, reject) => {
    const obj = BID_CART_PAGINATE;
    obj.request = {
      trackType: trackTypeObj.BIDCART,
    };
    UtilService.callApi(obj, (err, data) => {
      if (err) reject(err);
      if (data && data.code === 'OK') return resolve(data.data);
      reject(err);
    });
  });
}

export function getColumn(columnList = null) {
  const Columns = [];
  if (localStorage.getItem(`${LOCAL_STORAGE_VAR}-column`) || localStorage.getItem(`${LOCAL_STORAGE_VAR}-lgd-column`) || columnList) {
    const getColumnList = columnList 
      ? columnList 
      : (localStorage.getItem(`${LOCAL_STORAGE_VAR}-labGrown`) === 'Y') 
        ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-lgd-column`)) 
        : JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-column`));
    if (
      [
        LISTINGPAGES.CART,
        LISTINGPAGES.WATCHLIST,
        LISTINGPAGES.QUOTE,
        LISTINGPAGES.CONFIRM,
        LISTINGPAGES.PURCHASE,
        LISTINGPAGES.SAVEDSEARCH,
        LISTINGPAGES.MYDEMAND,
      ].includes(getPath())
    ) {
      const creatDate = {
        cellClass: 'text-left',
        field: 'createdAt',
        isActive: true,
        key: 'createdAt',
        title: 'Date',
        width: 70,
      };
      getColumnList.splice(2, 0, creatDate);
    }
    getColumnList.map((dataa) => {
      const data = {};
      Object.keys(dataa).map((x) => (data[x.trim()] = dataa[x]));
      if (data.isActive && data.field) {
        data.title = data.title.trim();
        data.field = data.field.trim();
        const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
        // if (userData && userData.account) {
        //   if (userData.account.isApproved !== KYC_STATUS.APPROVED) {
        //     if (data.field === 'amt' || data.field === 'ctPr' || data.field === 'back') return false;
        //   }
        // } else {
        //   if (data.field === 'amt' || data.field === 'ctPr' || data.field === 'back') return false;
        // }
        const canFilter = FILTER_COLUMNS.includes(data.field);
        if (data.field === 'reminderDate' && getPath() !== LISTINGPAGES.REMINDER) return false;
        if (data.field === 'remarks' && getPath() !== LISTINGPAGES.CONFIRM) return false;

        Columns.push({
          Header: data.title,
          accessor: data.field,
          id: data.field,
          desc: data.desc,
          link: data.link,
          Filter: canFilter ? ColumnFilter : <></>,
          filter: filterArrayIncludes,
          Cell({ row, cell }) {
            // className certificateNo redColor greenColor
            return (
              <div
                className={
                  data.field === 'stoneId' || data.field === 'vStnId'
                    ? `underline`
                    : FLOAT_COLUMNS.includes(data.field) || ROUND_COLUMNS.includes(data.field)
                      ? 'numberValue'
                      : null
                }
              >
                {data.isFlag && cell.value ? (
                  typeof data.sLabel === 'string' ? (
                    data.sLabel
                  ) : (
                    'Yes'
                  )
                ) : data.isFlag && !cell.value ? (
                  typeof data.nLabel === 'string' ? (
                    data.nLabel
                  ) : (
                    '-'
                  )
                ) : cell.value === true ? (
                  'Y'
                ) : // : !cell.value ? (
                  //   "-"
                  // )
                  data.field === 'ctPr' ? (
                    <div
                      className={
                        'priceChange'

                        // +(row.index % 2 === 0 ? ' greenColor' : ' redColor')
                      }
                    >
                      {parseFloat(row.original.ctPr).toFixed(2)}
                      {/* <span className='downPrice'>({row.index % 2 === 0 ? '-' : '+'}2%)</span> */}
                    </div>
                  ) : data.field === 'amt' ? (
                    <div
                      className={
                        'priceChange'

                        // +(row.index % 2 === 0 ? ' greenColor' : ' redColor')
                      }
                    >
                      {parseFloat(row.original.amt).toFixed(2)}
                      {/* <span className='downPrice'>({row.index % 2 === 0 ? '-' : '+'}2%)</span> */}
                    </div>
                  ) : data.field === 'reminderDate' ? (
                    moment(row.original.reminderDate).format('ll')
                  ) : data.field === 'createdAt' ? (
                    row?.original?._original?.createdAt ? (
                      moment(row?.original?._original?.createdAt).format('DD/MM/YYYY hh:mm A')
                    ) : (
                      moment(row?.original?.createdAt).format('DD/MM/YYYY hh:mm A')
                    )
                  ) : row.original.isFcCol === true && data.field === 'colNm' ? (
                    <div className="normalTableDropdown">
                      <span className="tableDropdownTitle">
                        {/* {`${row.original.intenNm} ${row.original.ovrtnNm}`} */}
                        {`${row.original.fcColDesc ? row.original.fcColDesc : '-'}`}
                      </span>
                      <div className="tableDropdown">
                        {/* {[
                          row.original.intenNm,
                          row.original.ovrtnNm,
                          row.original.fcColNm,
                        ]
                          .filter(function (el) {
                            return el && el;
                          })
                          .map((d) => {
                            return <span>{d}</span>;
                          })} */}
                        {row.original.fcColDesc ? row.original.fcColDesc : ''}
                      </div>
                    </div>
                  ) : data.field === 'locNm' ? (
                    <>
                      <Tooltip title={cell.value.toUpperCase()}>
                        {FLAGICON[cell.value.toUpperCase()] ? (
                          <img
                            className="tablemapImg"
                            width="30px"
                            src={FLAGICON[cell.value.toUpperCase()]}
                            alt={row.original[data.field]}
                          />
                        ) : (
                          cell.value
                        )}
                      </Tooltip>
                    </>
                  ) : data.field === 'back' && getPath() === LISTINGPAGES.WATCHLIST ? (
                    row.original.back !== row.original.prvBack && row.original.prvBack ? (
                      <div
                        className={`newDiscount ${row.original.back < 0
                          ? row.original.back > row.original.prvBack
                            ? `red`
                            : `green`
                          : row.original.back < row.original.prvBack
                            ? `green`
                            : `red`
                          }`}
                      >
                        <span>{row.original.back}</span> | <del>{row.original.prvBack} </del>
                        {row.original.back < 0 && row.original.prvBack ? (
                          row.original.back > row.original.prvBack ? (
                            <img src={upArrowRed} height={15} />
                          ) : (
                            <img src={downArrowGreen} height={15} />
                          )
                        ) : row.original.back > 0 && row.original.prvBack ? (
                          row.original.back < row.original.prvBack ? (
                            <img src={downArrowGreen} height={15} />
                          ) : (
                            <img src={upArrowRed} height={15} />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center' }}>
                        <span>{row.original.back}</span>
                      </div>
                    )
                  ) : FLOAT_COLUMNS.includes(data.field) ? (
                    formatNumber(parseFloat(cell.value))
                  ) : ROUND_COLUMNS.includes(data.field) ? (
                    formatNumber(Math.round(cell.value))
                  ) : data.field === 'cutNm' ? (
                    row.original.shpNm === 'ROUND' ? (
                      cell.value
                    ) : (
                      '-'
                    )
                  ) : data.field === 'lbNm' && row.original.sSts === 'C' ? (
                    (cell.value = row.original.sStsDesc)
                  ) : !cell.value ? (
                    '-'
                  ) : data.field === 'shdNm' && row.original.shdNm === 'NONE' ? (
                    '-'
                  ) : data.field === 'mlkNm' && row.original.mlkNm === 'NONE' ? (
                    '-'
                  ) : data.field === 'mixTintNm' && row.original.mixTintNm === 'NONE' ? (
                    '-'
                  ) : (
                    cell.value
                  )}
              </div>
            );
          },
        });
      }
    });
  }
  return Columns;
}

export function handleAlter(array, item, key) {
  let checked = _.cloneDeep(array) || [];
  if (_.find(checked, { [key]: item[key] })) checked = checked.filter((el) => el[key] !== item[key]);
  else checked.push(item);
  return checked;
}

export function getParams(props_row) {
  const params = [
    // inside ? null : props_row.shpNm,
    // inside ? null : props_row.lbNm,
    parseFloat(props_row.crt),
    props_row.isFcCol ? props_row.fcColNm : props_row.colNm,
    props_row.clrNm,
    props_row.cutNm,
    props_row.polNm,
    props_row.symNm,
    // inside ? null : props_row.fluNm
  ].filter((el) => {
    return el && el;
  });
  return params;
}

export function getStoneInfo(props_row) {
  const params = [
    props_row.vStnId,
    props_row.shpNm,
    parseFloat(props_row.crt),
    props_row.isFcCol ? props_row.fcColNm : props_row.colNm,
    props_row.clrNm,
    props_row.cutNm,
    props_row.polNm,
    props_row.symNm,
    props_row.fluNm,
  ].filter((el) => {
    return el && el;
  });
  return params;
}

export function getStoneTitle(obj) {
  const params = obj.map((p) => ({
    shp: p.shpNm,
    crt: parseFloat(p.crt),
    col: p.isFcCol ? p.fcColNm : p.colNm,
    clr: p.clrNm,
    cut: p.cutNm,
    pol: p.polNm,
    sym: p.symNm,
  }));
  let display = [];
  const keyArr = ['shp', 'crt', 'col', 'clr', 'cut', 'pol', 'sym'];
  keyArr.map((key) => {
    const word = _.groupBy(params, key);
    if (_.size(word) === 1) display.push(params[0][key]);
  });
  display = display.filter((el) => el && el).join(' ');
  return display;
}

export function compareStones(list) {
  if (list.length === 0) {
    OpenNotification({ type: 'error', title: 'Please select stone(s) to compare.' });
    return;
  }
  if (list.length > 15) {
    OpenNotification({ type: 'error', title: 'You can compare maximum 15 diamonds.' });
    return;
  }
  let data =
    // localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`)
    //     ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`))
    //     :
    [];
  list.map((x) => data.push(x.id));

  diatrackTrack("compare", list);

  data = _.uniq(data);
  if (data.length === 1) {
    OpenNotification({ type: 'error', title: 'Please select minimum two stones to compare.' });
    return;
  }
  if (data.length > 15) {
    data = data.slice(data.length - 15, data.length);
  }
  localStorage.setItem(`${LOCAL_STORAGE_VAR}-compare-diamond`, JSON.stringify(data));
  localStorage.setItem(`${LOCAL_STORAGE_VAR}-now`, JSON.stringify(window.location.pathname + window.location.search));
  window.open('/compare');
}

export function fetchDiamondList(state, filters, cb) {
  const obj = {
    method: SEARCH_DIAMOND_LIST.method,
    url: SEARCH_DIAMOND_LIST.url,
    request: {
      filters,
      isAppendMasters: true,
      page: state.page,
      limit: state.limit,
      sort: state.sort,
      // isSkipSave: true
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    let searchFilter = {};
    let inTrackDiamonds = [];
    const filterArray = {};
    if (data && data.code === 'OK') {
      searchFilter = data.data[0].filter;
      rows = data?.data?.[0]?.diamonds;
      sum = data?.data?.[0]?.total?.[0];
      count = data?.data?.[0]?.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data?.data?.[0]?.inTrackDiamonds;
    }
    cb({
      data: rows,
      searchFilter,
      seachFilterTag: searchFilter,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchStoneOfDay(state, type, cb) {
  // let obj = FEATURE_STONE
  const obj = {
    ...SEARCH_DIAMOND_LIST,
  };

  obj.request = {
    filters: [
      {
        wSts: ['D'],
        labGrown: store.getState().commonData.labGrown
      },
    ],
    // type,
    page: state.page,
    limit: state.limit,
    sort: state.sort,
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    const sum = {};
    const seachFilterTag = {};
    let inTrackDiamonds = [];
    const filterArray = {};
    if (data && data.code === 'OK') {
      //seachFilterTag = data.data[0].filter
      // Old code has list
      // rows = data.data.list //_.flatten(data.data.list.map(x => x.featuredPair))
      rows = data.data[0].diamonds;
      count = data.data[0].count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data[0].inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchMatchPair(state, diamondSearchId, cb) {
  const obj = CREATE_MATCH_PAIR;
  obj.request = {
    filter: {
      diamondSearchId,
      labGrown: store.getState().commonData.labGrown,
    },
    page: state.page,
    limit: state.limit,
    sort: state.sort,
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    let inTrackDiamonds = [];
    const filterArray = {};
    if (data && data.code === 'OK') {
      const grp = _.groupBy(data.data.list, 'groupNo');
      Object.keys(grp).map((grpNo) => {
        const val = grp[grpNo];
        val[0].isMatchHeader = true;
        val[0].groupingTitle = getStoneTitle(val);
        val[0].totalDiamonds = val.length;
        val[0].groupData = {};
        TOTAL_COLUMNS.map((i) => {
          val[0].groupData[i] = [];
          val.map((x) => {
            if (x[i]) val[0].groupData[i].push(x[i]);
            return true;
          });
          return true;
        });
        rows = [...rows, ...val];
      });
      sum = data.data.total[0];
      count = data.data.count;
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchConfirmStone(state, purchase, cb) {
  const obj = {
    method: FETCH_CONFIRM_STONE.method,
    url: FETCH_CONFIRM_STONE.url,
    request: {
      sort: [{ memoNo: 'DESC' }],
      page: state.page,
      limit: state.limit,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  obj.request.filter = {
    status: purchase ? DIAMONDCONFIRM.STATUS.ACCEPTED : DIAMONDCONFIRM.STATUS.PENDING,
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    const sum = {};
    const seachFilterTag = {};
    const inTrackDiamonds = [];
    const filterArray = {};
    if (data && data.code === 'OK') {
      const grp = data.data.list.filter((x) => x.memoDetails && x.memoDetails.length);

      _.each(grp, (x) => {
        const val = x.memoDetails;
        const obj = _.omit(x, 'memoDetails');

        val[0] = {
          ...val[0],
          isConfirmHeader: true,
          ...obj,
          totalDiamonds: val.length,
        };
        rows = [...rows, ...val];
      });
      rows = _.uniqBy(rows, 'vStnId');
      count = data.data.count;
    }

    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchCart(state, cb) {
  const obj = {
    method: FETCH_DIAMOND_TRACK.method,
    url: FETCH_DIAMOND_TRACK.url,
    request: {
      page: state.page,
      limit: state.limit,
      trackType: trackTypeObj.CART,
      sort: state.sort,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      rows = data.data.list.map((x) => ({ _original: x, ...x.diamond }));
      sum = data.data.total[0];
      count = data.data.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchOffer(state, cb) {
  const obj = {
    method: FETCH_DIAMOND_TRACK.method,
    url: FETCH_DIAMOND_TRACK.url,
    request: {
      page: state.page,
      limit: state.limit,
      trackType: trackTypeObj.QUOTE,
      sort: state.sort,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      rows = data.data.list.map((x) => ({
        ...x.diamond,
        _original: x,
        offerValidDate: x.offerValidDate,
        remarks: x.remarks,
        newDiscount: x.newDiscount,
        newAmount: x.newAmount,
        newPricePerCarat: x.newPricePerCarat,
        offerStatus: x.offerStatus,
        updatedAt: x.updatedAt,
        trackId: x.id,
        grpBy: x.updatedAt.split('T')[0],
      }));
      const grp = _.groupBy(rows, 'grpBy');
      rows = [];
      Object.keys(grp).map((key) => {
        grp[key][0].isOfferHeader = true;
        rows = [...rows, ...grp[key]];
      });
      sum = data.data.total[0];
      count = data.data.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchWatch(state, cb) {
  const obj = {
    method: FETCH_DIAMOND_TRACK.method,
    url: FETCH_DIAMOND_TRACK.url,
    request: {
      page: state.page,
      limit: state.limit,
      trackType: trackTypeObj.WATCHLIST,
      sort: state.sort,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      rows = data.data.list.map((x) => ({ _original: x, ...x.diamond }));
      sum = data.data.total[0];
      count = data.data.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchReminder(state, cb) {
  const obj = {
    method: FETCH_DIAMOND_TRACK.method,
    url: FETCH_DIAMOND_TRACK.url,
    request: {
      page: state.page,
      limit: state.limit,
      trackType: trackTypeObj.REMINDER,
      sort: state.sort,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      rows = data.data.list.map((x) => ({
        ...x.diamond,
        _original: x,
        reminderDate: x.reminderDate,
      }));
      sum = data.data.total[0];
      count = data.data.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchOffice(state, cb) {
  const obj = {
    method: FETCH_DIAMOND_TRACK.method,
    url: FETCH_DIAMOND_TRACK.url,
    request: {
      page: state.page,
      limit: state.limit,
      trackType: trackTypeObj.OFFICE,
      sort: state.sort,
      labGrown: store.getState().commonData.labGrown,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      const grp = [];

      data.data.list.map((x) => {
        grp.push({ ...x.diamond, _original: x, reminderDate: x.reminderDate });
      });

      const grpData = _.groupBy(grp, 'reminderDate');

      Object.keys(grpData).map((grpNo) => {
        const val = grpData[grpNo];

        val[0] = {
          ...val[0],
          isConfirmHeader: true,
          totalDiamonds: val.length,
        };
        rows = [...rows, ...val];
      });
      rows = _.uniqBy(rows, 'vStnId');

      sum = data.data.total[0];
      count = data.data.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data.data.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export function fetchDiamondPaginate(state, type, cb, filtr = {}) {
  const newFilter = !_.isEmpty(filtr) //DO NOT CHANGE
    ? [filtr]
    : [type.viewType ? {} : { wSts: type, ...filtr }];
  const labGrown = store.getState().commonData.labGrown;

  const sort = getPath() === LISTINGPAGES.SPECIAL;
  let obj = {
    method: SEARCH_DIAMOND_LIST.method,
    url: SEARCH_DIAMOND_LIST.url,
    request: {
      page: state.page,
      limit: state.limit,
      filters: newFilter.map(x => ({ ...x, labGrown })),
      sort: sort ? [{ crt: 'DESC' }] : state.sort,
      viewType: type.viewType,
    },
  };
  if (type?.featuredStone) {
    obj = { ...obj, request: { ...obj.request, featuredStone: true } };
  }

  return UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      rows = data.data[0]?.diamonds;
      sum = data.data[0]?.total?.[0];
      count = data.data[0]?.count;
      FILTER_COLUMNS.map((x) => {
        filterArray[x] = _.uniq(rows.map((r) => r[x]));
      });
      inTrackDiamonds = data?.data?.inTrackDiamonds;
    }
    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

function diatrackTrack(trackType, diamonds) {
  const eventData = new FormData();
  console.log(diamonds)
  eventData.append("stone_ids", JSON.stringify(diamonds.map(x => x.vStnId)));
  eventData.append("event_type", Object.keys(trackTypeObj).find(x => trackTypeObj[x] == trackType)?.toLowerCase() || trackType.ToString())
  diatrack(eventData);
}

export const handleInsertTrack = (trackType, selected, cb = () => { }, date, remark) => {
  const diamonds = [];
  selected.map((s) =>
    diamonds.push({
      diamond: s.id,
      trackPricePerCarat: s.ctPr,
      trackAmount: s.amt,
    }),
  );
  const obj = {
    reminderDate: date,
    trackType,
    diamonds,
    remark,
  };
  const api = CREATE_TRACK.url;
  const objData = {
    method: CREATE_TRACK.method,
    url: api,
    request: obj,
  };
  UtilService.callApi(objData, (err, data) => {
    const flag =
      trackType !== trackTypeObj.REMINDER
        ? true
        : data &&
          data.data &&
          data.data.created &&
          data.data.created.length === 0 &&
          data.data.exists &&
          data.data.exists.length !== 0
          ? false
          : true;
    if (data && data.code === 'OK' && flag) {
      OpenNotification({ type: 'success', title: data.message });
      cb(true);
    } else {
      OpenNotification({ type: 'error', title: data ? data.message : err && err.data ? err.data.message : '' });
      cb(false);
    }
  });
  diatrackTrack(trackType, selected);
};

export const handleUpsertTrack = (trackType, selected, inTrackDiamonds, cb, date) => {
  const ids = selected.map((x) => x.id);
  const id = [];
  const diamonds = _.find(inTrackDiamonds, { _id: trackType })
    ? _.find(inTrackDiamonds, { _id: trackType }).diamonds
    : [];
  if (diamonds) {
    _.each(ids, (diamondId) => {
      const trackId = _.find(diamonds, { id: diamondId });
      if (trackId) id.push(_.find(diamonds, { id: diamondId }).trackId);
    });
    diatrackTrack(trackType, selected);
  }
  const obj = {
    reminderDate: date,
    trackType,
    id,
  };
  const api = UPDATE_TRACK.url;
  const objData = {
    method: UPDATE_TRACK.method,
    url: api,
    request: obj,
  };
  UtilService.callApi(objData, (err, data) => {
    if (data && data.code === 'OK') {
      cb(true);
      return OpenNotification({ type: 'success', title: data.message });
    } else {
      OpenNotification({ type: 'error', title: data ? data.message : err && err.data ? err.data.message : '' });
      cb(false);
    }
  });
};

export const handlePrint = (filter, id, type, cb) => {
  const objData = {
    ...PRINT_PDF,
    request: isEmpty(id) ? { filter } : { id },
  };
  if (filter?.viewType) {
    const req = objData.request;
    //req.viewType = 2;
    if (id.length === 0) {
      req.viewType = 2;
      req.filter = {
        isFm: {
          nin: ['CERT', 'ELIG'],
        },
      };
    } else {
      req.filter = {};
      delete [req.viewType];
    }
    objData.request = req;
  }
  UtilService.callApi(objData, async (err, data) => {
    if (err) throw err;
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data;
      window.open(file_path, 'Download');
    }
  });
};

export const handlePrintTrack = (filter, orderDiamond, type, cb) => {
  const objData = {
    ...PRINT_PDF,
    request: isEmpty(orderDiamond) ? { filter } : { orderDiamond },
  };
  if (filter.viewType) {
    const req = objData.request;
    //req.viewType = 2;
    if (orderDiamond.length === 0) {
      req.viewType = 2;
      req.filter = {
        isFm: {
          nin: ['CERT', 'ELIG'],
        },
      };
    } else {
      req.filter = {};
      delete [req.viewType];
    }
    objData.request = req;
  }
  UtilService.callApi(objData, async (err, data) => {
    if (err) throw err;
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data;
      window.open(file_path, 'Download');
    }
  });
};

export const handleDownloadExcel = (summary, filter = {}, id, cb, fileName) => {
  const allSummary = summary;
  const sheetName = !isEmpty(fileName) ? fileName : undefined;
  const objData = {
    ...EXPORT_EXCEL,
    request: {
      sheetName,
      allSummary,
      ...(isEmpty(id) ? { filter } : { id }),
    },
  };

  if (filter.viewType) {
    const req = objData.request;
    //req.viewType = 2;
    if (id.length === 0) {
      req.viewType = 2;
      req.filter = { isFm: { nin: ['CERT', 'ELIG'] } };
    } else {
      req.filter = {};
      delete [req.viewType];
    }
    objData.request = req;
  }
  UtilService.callApi(objData, async (err, data) => {
    if (err) throw err;
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.data;
      window.open(file_path, 'Download');
      cb(true);
    }
  });
};

export const handleDownloadExcelTrack = (allSummary, filter = {}, orderDiamond, cb, fileName) => {
  const sheetName = !isEmpty(fileName) ? fileName : undefined;

  const objData = {
    ...EXPORT_EXCEL,
    request: {
      sheetName,
      allSummary,
      ...(isEmpty(orderDiamond) ? { filter } : { orderDiamond }),
    },
  };
  if (filter.viewType) {
    const req = objData.request;
    //req.viewType = 2;
    if (orderDiamond.length === 0) {
      req.viewType = 2;
      req.filter = {
        isFm: {
          nin: ['CERT', 'ELIG'],
        },
      };
    } else {
      req.filter = {};
      delete [req.viewType];
    }
    objData.request = req;
  }
  UtilService.callApi(objData, async (err, data) => {
    if (err) throw err;
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.data;
      window.open(file_path, 'Download');
      cb(true);
    }
  });
};
export const handleDownloadMultiple = (filter = {}, id = [], obj, cb) => {
  const self = this;

  const objData = {
    ...DOWNLOAD_ZIP_EXCEL,
    request: { filter: _.isEmpty(filter) ? { id } : { filter }, ...obj },
  };
  UtilService.callApi(objData, async (err, data) => {
    if (err) throw err;
    if ((await data) && data.code === 'OK') {
      const server = BASE_URL;
      const file_path = `${server}/${data.data}`;
      window.open(file_path, '_blank');
      // window.open(file_path, 'Download')
      cb(true);
    }
  });
};
export function handleConfirmStone(ids, comment, cb) {
  const obj = { ...CONFIRM_STONE, request: { diamonds: ids, comment } };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      OpenNotification({ type: 'success', title: data.message });
      cb(true);
    } else {
      OpenNotification({ type: 'error', title: data ? data.message : err && err.data ? err.data.message : '' });
      cb(false);
    }
  });
}

export function handleTrackDelete(trackType, ids, inTrackDiamonds, cb) {
  const id = [];
  const diamonds = _.find(inTrackDiamonds, { _id: trackType })
    ? _.find(inTrackDiamonds, { _id: trackType }).diamonds
    : [];
  if (diamonds) {
    _.each(ids, (diamondId) => {
      const trackId = _.find(diamonds, { id: diamondId });
      if (trackId) id.push(_.find(diamonds, { id: diamondId }).trackId);
    });
  }
  const obj = {
    method: DELETE_TRACK.method,
    url: DELETE_TRACK.url,
    request: {
      trackType,
      id,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      OpenNotification({ type: 'success', title: data.message });
      cb(true);
    } else {
      OpenNotification({ type: 'error', title: data ? data.message : err && err.data ? err.data.message : '' });
    }
  });
}

export const handleSendEmail = (apiObj, cb) => {
  const obj = {
    method: EXPORT_EXCEL.method,
    url: EXPORT_EXCEL.url,
    request: apiObj,
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      cb(true);
      return OpenNotification({ type: 'success', title: data.message });
    } else {
      cb(false);
      return OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
  });
};

export function handleBidUpsert(rows, id, code, result, cb) {
  const obj = getPath() === LISTINGPAGES.MYBID ? UPDATE_BID : CREATE_BID;

  obj.request =
    getPath() === LISTINGPAGES.MYBID
      ? {
        // bidTermsDiscount: termObj,
        id,
        //bidConfigurationType: 1,
        result_type: parseFloat(result),
        diamonds: rows.map((x) => ({
          id: x.trackId,
          bidPricePerCarat: x.bidPricePerCarat,
          bidDiscount: x.isFcCol ? 0 : x.bidDiscount,
          bidAmount: x.bidAmount,
          trackPricePerCarat: x.ctPr,
          trackAmount: x.amt,
          trackDiscount: x.back,
          deviceType: 1,
          status: x.status,
        })),
      }
      : {
        //bidType: type,
        bidConfigurationId: id,
        subTypeCode: code,
        //bidConfigurationType: 1,
        // bidTermsDiscount: termObj,
        result_type: parseFloat(result),
        diamonds: rows.map((x) => ({
          diamond: x.id,
          bidPricePerCarat: x.bidPricePerCarat,
          bidAmount: x.bidAmount,
          bidDiscount: x.isFcCol ? 0 : x.bidDiscount,
          trackPricePerCarat: x.ctPr,
          trackAmount: x.amt,
          trackDiscount: x.back,
          vnd: x.vnd,
          vStnId: x.vStnId,
        })),
      };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      OpenNotification({
        type: 'success',
        title: data.message,
      });
      cb(true);
    } else {
      OpenNotification({
        type: 'error',
        title: err && err.data ? err.data.message : data.message,
      });
      cb(false);
    }
  });
}
function offerObject(item, expire) {
  return {
    diamond: item.trackId,
    trackPricePerCarat: item.ctPr,
    trackAmount: item.amt,
    trackDiscount: item.back,
    vStnId: item.vStnId,
    newAmount: item.finalquote,
    newPricePerCarat: item.quote,
    newDiscount: item.offerDis,
    offerValidDate: moment(expire),
    // offerValidDate: moment().add(item.hours, "hours"),
  };
}
export function handleSaveQuote(selectedItems, expire, comment, cb, update) {
  const obj = update ? UPDATE_TRACK : CREATE_TRACK;
  const item = selectedItems[0];
  obj.request = update
    ? {
      trackType: trackTypeObj.QUOTE,
      remarks: comment,
      id: item.trackId,
      ...offerObject(item, expire),
    }
    : {
      trackType: trackTypeObj.QUOTE,
      remarks: comment,
      diamonds: selectedItems.map((x) => ({
        ...offerObject(x, expire),
        diamond: x.id,
      })),
    };

  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      OpenNotification({ type: data.data.created.length === 0 ? 'error' : 'success', title: data.message });
      if (data.data.created.length > 0) cb(true);
      else cb(false);
    } else {
      OpenNotification({ type: 'error', title: err && err.data ? err.data.message : data.message });
      cb(false);
    }
  });
}

export const handleSendXRayEmail = (apiObj, path, cb) => {
  apiObj.message = `${apiObj.message} <a href=${path}> View File</a>`;
  const obj = {
    method: SEND_EMAIL_XRAY.method,
    url: SEND_EMAIL_XRAY.url,
    request: apiObj,
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      cb(true);
      return OpenNotification({ type: 'success', title: data.message });
    } else {
      cb(false);
      return OpenNotification({ type: 'error', title: data.message });
    }
  });
};

export function allSortObject(columns) {
  const sort = {};
  _.each(columns, (col) => {
    if (col.id !== 'Details') sort[col.id] = col.Header;
  });
  return sort;
}

export function getProjectSetting(type, cb) {
  const obj = PROJECT_SETTING;
  obj.request = {
    filter: {
      type,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') cb(data.data.data);
    else cb([]);
  });
}

export const downloadZip = (id, cb) => {
  const obj = {
    method: DOWNLOAD_ZIP.method,
    url: DOWNLOAD_ZIP.url,
    request: {
      id,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.path;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    cb(true);
  });
};

export const downloadFile = (apiObj) => {
  // document.body.classList.add('loading-indicator');
  const obj = {
    method: DOWNLOAD_FILE.method,
    url: DOWNLOAD_FILE.url,
    request: apiObj,
  };

  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.path;
      const xhr = new XMLHttpRequest();
      xhr.open(
        'GET',
        file_path, //apiObj.path,
        true,
      );
      xhr.responseType = 'blob';
      xhr.onload = function () {
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(this.response);
        const tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = apiObj.fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      };

      // xhr.onerror = (err) => {
      //   // document.body.classList.remove('loading-indicator');
      // };
      // document.body.classList.remove('loading-indicator');
      xhr.send();
    } else {
      // return OpenNotification({ type: 'error', title: err.data?.message || data?.message });
    }
  });
};

export const downloadVideo = (apiObj) => {
  // document.body.classList.add('loading-indicator');
  const obj = {
    method: DOWNLOAD_ZIP_EXCEL.method,
    url: DOWNLOAD_ZIP_EXCEL.url,
    request: {
      diamonds: [apiObj.id],
      mp4Video: true,
      zip: false,
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_URL;
      const file_path = server + '/' + data.data[0];

      const xhr = new XMLHttpRequest();
      xhr.open(
        'GET',
        file_path, //apiObj.path,
        true,
      );
      xhr.responseType = 'blob';
      xhr.onload = function () {
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(this.response);
        const tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = apiObj.fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
        // document.body.classList.remove('loading-indicator');
      };

      // xhr.onerror = (err) => {
      //   // document.body.classList.remove('loading-indicator');
      // };
      setTimeout(() => {
        xhr.send();
        // document.body.classList.remove("loading-indicator");
      }, 10000);
    } else {
      // return OpenNotification({ type: 'error', title: err?.data?.message || data?.message });
    }
  });
};

export function fetchOfficeList(state, cb) {
  const obj = FETCH_OFFICE_DIAMOND;
  obj.request = {
    page: state.page,
    limit: state.limit,
    sort: [{ date: 'ASC' }],
    labGrown: store.getState().commonData.labGrown,
    // type: 1
  };
  UtilService.callApi(obj, (err, data) => {
    let rows = [];
    let count = 0;
    let sum = {};
    const seachFilterTag = {};
    const filterArray = {};
    let inTrackDiamonds = [];
    if (data && data.code === 'OK') {
      if (!isEmpty(data.data)) {
        const grp = data.data.list.filter((x) => x.diamonds && x.diamonds.length);
        _.each(grp, (x) => {
          const val = x.diamonds;
          val[0] = {
            ...val[0],
            _original: x,
            isOfficeHeader: true,
            cabinSlot: x.cabinSlot,
            date: x.date,
            // slottId: x.id,
          };
          _.each(val, (all) => {
            all.slottId = x.id;
          });
          rows = [...rows, ...val];
        });
        // rows = _.uniqBy(rows, "vStnId");
        count = data.data.count;
        sum = data.data.total;
        FILTER_COLUMNS.map((x) => {
          filterArray[x] = _.uniq(rows.map((r) => r[x]));
        });
        inTrackDiamonds = data.data.inTrackDiamonds;
      }
    }

    cb({
      data: rows,
      seachFilterTag,
      sum,
      count,
      filterArray,
      selectedFilterArray: {},
      inTrackDiamonds,
    });
  });
}

export const handleDeleteOffice = (filter, cb) => {
  const self = this;

  const objData = {
    ...DELETE_OFFICE_DIAMOND,
    request: filter,
  };
  UtilService.callApi(objData, (err, data) => {
    if (err) throw err;
    if (data && data.code === 'OK') {
      cb(true);
    }
  });
};

export const myAccountExcelTrack = (allSummary, trackType) => {
  const obj = {
    ...FETCH_DIAMOND_TRACK,
    request: {
      isExcel: true,
      allSummary,
      page: 1,
      limit: 100000,
      trackType,
      sort: {},
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};

export const myAccountExcelMemo = (allSummary, filter) => {
  const obj = {
    ...FETCH_CONFIRM_STONE,
    request: {
      isExcel: true,
      allSummary,
      page: 1,
      limit: 100000,
      filter,
      sort: [{ memoNo: 'DESC' }],
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};
export const myAccountExcelOffice = (allSummary) => {
  const obj = {
    ...FETCH_OFFICE_DIAMOND,
    request: {
      isExcel: true,
      allSummary,
      page: 1,
      limit: 100000,
      sort: [{ date: 'ASC' }],
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};

export const myAccountPrintTrack = (trackType) => {
  const obj = {
    ...FETCH_DIAMOND_TRACK,
    request: {
      isPdf: true,
      page: 1,
      limit: 100000,
      trackType,
      sort: {},
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};

export const myAccountPrintMemo = (filter) => {
  const obj = {
    ...FETCH_CONFIRM_STONE,
    request: {
      isPdf: true,
      page: 1,
      limit: 100000,
      filter,
      sort: [{ memoNo: 'DESC' }],
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};
export const myAccountPrintOffice = () => {
  const obj = {
    ...FETCH_OFFICE_DIAMOND,
    request: {
      isPdf: true,
      page: 1,
      limit: 100000,
      sort: [{ date: 'ASC' }],
    },
  };
  UtilService.callApi(obj, (err, data) => {
    if (data && data.code === 'OK') {
      const server = BASE_DOWNLOAD_URL;
      const file_path = server + data.data;
      window.open(file_path, 'Download');
    } else {
      // OpenNotification({ type: 'error', title: err.data.message || data.message });
    }
    //cb(true);
  });
};
